import React from 'react'
import Modal from 'react-bootstrap/Modal';
import { ServerRequestProtected } from "../../utils/ServerDataRequest"
import NotificationHandler from "../../utils/NotificationHandler"
import { enumUtil } from "../../utils/Enum"
import { useState } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import DeleteReduxDropDown from '../shared/DeleteReduxDropDown';
import { GeneralDropDowns } from '../../actions/GeneralPatientActions';
import Loader from '../shared/Loader/Loader';
import isNull from '../../utils/NullChecking';
import { ModalBody } from 'reactstrap';
const DeleteConfirmatiom = (props) => {
    const dispatch = useDispatch()
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)

    const { isOpenAlert, onCloseDelete, onClose, dropDown, API_URL, type } = { ...props }

    const [isLoading, setIsLoading] = useState(false)
    let endPoint = type === "DeleteMasterWeek" ? "/DeleteMasterWeek" :
        "/DeleteSingleRecord";
    let record = props.ID ?
        { "ID": props.ID + "" } :
        ["DeleteMasterWeek", "PaymentsCheck", "PatientMessages"].includes(type) ? { ...props.payload } :
            { "value": props.value + "" }
    const handleDelete = () => {
        setIsLoading(true)
        ServerRequestProtected(API_URL + endPoint, 'post', {
            // ...record,
            ...(type === "DeleteMasterWeek" ? { DeleteData: { ...record } } : { ...record }),
            "TableName": props.TableName
        }).then((response) => {
            setIsLoading(false)
            NotificationHandler('Record Deleted Successfully!', enumUtil.enumtoaster.success)
            const TableNameKey = {
                'Location': 'Location',
                'Provider': 'Provider',
                'RefProvider': 'RefProvider',
                'Insurance': 'Insurance',
                'BillingProvider': 'BillingProvider',
                'POS': 'POS',
                'CoOrdinator': 'CoOrdinator',
                'Marketer': 'Marketer',
                'BILLINGSTATUS': 'BILLINGSTATUS',
                'Shifts': 'Shifts',
                // 'RemarkCode': 'RemarkCode'

            }
            const tableName = props.TableName

            if (TableNameKey.hasOwnProperty(tableName)) {
                const reduckey = TableNameKey[tableName]
                let DeleteItem = DeleteReduxDropDown(props.ID || props.value, dropDown, props.TableName)

                dispatch(GeneralDropDowns({ ...DropDowns, [reduckey]: DeleteItem }));


            }
            else if (props.TableName === 'SubmitterReceiver') {
                let DeleteItem = DeleteReduxDropDown(props.ID, dropDown)
                dispatch(GeneralDropDowns({ ...DropDowns, Receiver: DeleteItem }));
            }
            if (!isNull(onClose)) {
                onClose()
            }
            if (!isNull(onCloseDelete)) {
                onCloseDelete()
            }
        }).catch((error) => {
            if (error) {
                NotificationHandler(error?.response?.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
                // onClose()
                onCloseDelete()
            }
        })

    }

    return (
        <>
            <Modal show={isOpenAlert} onHide={onCloseDelete} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 ar_delte_modal">
                {isLoading ? <Loader /> : null}
                <ModalBody>
                    <div className='d-flex justify-content-between delete-header align-items-center mb-12 p-0'>
                        <p className="heading dark-clr fs-14">Delete Action?</p>
                        <i className='icon-x-cros fs-20 dark-clr' onClick={onCloseDelete}></i>
                    </div>
                    <div className='undo-body p-0'>
                        {
                            props.Messsage ?
                                <div className='ar-alert d-flex mb-0'>
                                    <i className='icon-alert mt-1'></i>
                                    <div>
                                        <p className='text ms-1'>This action cannot be undone. All values
                                            associated with this will be lost.</p>
                                    </div>
                                </div>
                                : null
                        }
                        {
                            props.hideReason ?
                                <></>
                                :
                                <div className="input">
                                    <label className='heading'>Reason</label>
                                    <textarea rows="3" className='form-control'></textarea>
                                </div>
                        }
                    </div>
                </ModalBody>

                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                    <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onCloseDelete} >Cancel</button>
                    <button className='btn btn-danger px-10 h-100' onClick={handleDelete}>Delete</button>
                </div>
                {/* <Modal.Body>
                    <div className=''>
                        <div className='d-flex align-items-center gap-3 mb-2'>
                            <div className='delete-icon '>
                                <i className='icon-delete'></i>
                            </div>
                            <p className="heading">Delete Action?</p>
                        </div>
                        <p className="text text-start fs-14">Are u sure you want to delete. Once deleted cannot be recovered.</p>
                        <div className="input">
                            <label className='heading'>Reason</label>
                            <textarea rows="5" className='form-control'></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <div className='btns-group br-top-1 br-clr text-end py-2 px-3'>
                    <button className='btn btn-gray' onClick={onCloseDelete}>Cancel</button>
                    <button className='btn btn-danger' onClick={handleDelete}>Delete</button>
                </div> */}

            </Modal>
        </>
    )
}
export default DeleteConfirmatiom